import React from "react";
import { NumberInput } from "react-admin";
import { getPerGameStatValue, perGameCalc } from "util/stats";
import { useFormState, useForm } from "react-final-form";
import _ from "lodash";

const FormTab = (props) => {
  const { values } = useFormState();
  const form = useForm();
  const s = (fieldName) => `players.${props.index}.basketball.${fieldName}`;

  const updateStat = (event, updateField) => {
    const gameCount = _.get(values, s("playerGameCount"));
    const perGameStat = getPerGameStatValue(event, gameCount);
    form.change(s(updateField), perGameStat);
  };

  const updateAllRelatedStats = (event) => {
    if (!event || !event.target) return;
    const { value } = event.target;
    const stats = _.get(values, `players.${props.index}.basketball`);
    const { totalPoints, rebounds } = stats;
    const pointsPerGame = perGameCalc(totalPoints, value);
    const reboundsPerGame = perGameCalc(rebounds, value);

    form.change(s("pointsPerGame"), pointsPerGame);
    form.change(s("reboundsPerGame"), reboundsPerGame);
  };

  return (
    <>
      <NumberInput
        label="Player Game Count"
        source={s("playerGameCount")}
        onChange={updateAllRelatedStats}
      />
      <NumberInput
        label="Total Points"
        source={s("totalPoints")}
        onChange={(e) => updateStat(e, "pointsPerGame")}
      />
      <NumberInput
        label="Rebounds"
        source={s("rebounds")}
        onChange={(e) => updateStat(e, "reboundsPerGame")}
      />
      <NumberInput
        label="Assists"
        source={s("assists")}
        onChange={(e) => updateStat(e, "assistsPerGame")}
      />
      <NumberInput
        label="Three Point Field Goals"
        source={s("threePointFieldGoals")}
        onChange={(e) => updateStat(e, "threePointFieldGoalsPerGame")}
      />
      <NumberInput label="Points Per Game" source={s("pointsPerGame")} />
      <NumberInput label="Rebounds Per Game" source={s("reboundsPerGame")} />
      <NumberInput label="Assists Per Game" source={s("assistsPerGame")} />
      <NumberInput
        label="Three Point Field Goals Per Game"
        source={s("threePointFieldGoalsPerGame")}
      />
    </>
  );
};

export default FormTab;
